import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IGetOTPResponse } from "types/auth/IGetOTPResponse";
import { TGetCitiesResponse } from "types/public/API/getCityById/TGetCitiesResponse";
import { TGetCountryResponse } from "types/public/API/getCountryById/TGetCountryResponse";
import { TCities } from "types/public/API/getCityById/TCities";
import { TProvinces } from "types/public/API/getCountryById/TProvinces";

import { IVerifyOtp } from "../types/auth/IAuth";
import { baseApi } from "./base.api";
import { IGetFormResponse } from "types/public/API/getForm/IGetFormResponse";
import { IGetFormData } from "types/public/API/getForm/IGetFormData";
export const publicApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountryById: builder.query<TProvinces, void>({
      query: () => ({
        url: "/base-info/state/1",
        method: "GET",
      }),
      transformResponse: (response: TGetCountryResponse) => response.data,
    }),
    getCityById: builder.query<TCities, number>({
      query: (stateId) => ({
        url: `/base-info/city/${stateId}`,
        method: "GET",
      }),
      transformResponse: (response: TGetCitiesResponse) => response.data,
    }),
    getForm: builder.query<IGetFormData, void>({
      query: () => ({
        url: "/base-info/form",
        method: "GET",
      }),
      transformResponse: (response: IGetFormResponse) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCountryByIdQuery,
  useGetCityByIdQuery,
  useGetFormQuery,
} = publicApi;
